import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnswerTypeModalComponent } from './answer-type-modal.component';

@NgModule({
  declarations: [AnswerTypeModalComponent],
  imports: [CommonModule],
  exports: [AnswerTypeModalComponent],
})
export class AnswerTypeModalComponentModule {
  static getComponent() {
    return AnswerTypeModalComponent;
  }
}
